/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Summary_HintInputs */

const en_us2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume, records and what to adjust next time`)
};

const pt_br2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume, recordes e o que ajustar na próxima`)
};

const es_419_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen, récords y qué ajustar la próxima vez`)
};

const pt_pt2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume, recordes e o que ajustar da próxima vez`)
};

const fr_fr2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume, records et ce qu'il faut ajuster la prochaine fois`)
};

const de_de2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen, Rekorde und was du nächstes Mal anpassen kannst`)
};

const it_it2_profile_summary_hint = /** @type {(inputs: Profile_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume, record e cosa regolare la prossima volta`)
};

/**
* | output |
* | --- |
* | "Volume, records and what to adjust next time" |
*
* @param {Profile_Summary_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_summary_hint = /** @type {((inputs?: Profile_Summary_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Summary_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_summary_hint(inputs)
	if (locale === "es-419") return es_419_profile_summary_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_summary_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_summary_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_summary_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_summary_hint(inputs)
	return en_us2_profile_summary_hint(inputs)
});
export { profile_summary_hint as "profile.summary_hint" }